// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1nt6r","title":"ClientCherryInfo_title__3aGwR","itemText":"ClientCherryInfo_itemText__t6qaT"};